import script from "./TimerDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./TimerDisplay.vue?vue&type=style&index=0&id=10a8f12d&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a8f12d"]])

export default __exports__